import { render, staticRenderFns } from "./HyroxScoreRegistration.vue?vue&type=template&id=5dae5b93&scoped=true"
import script from "./HyroxScoreRegistration.vue?vue&type=script&lang=js"
export * from "./HyroxScoreRegistration.vue?vue&type=script&lang=js"
import style0 from "./HyroxScoreRegistration.vue?vue&type=style&index=0&id=5dae5b93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dae5b93",
  null
  
)

export default component.exports